import PropTypes from 'prop-types';

import Text from '@/shared-components/text/components/Text';

import './styles/AskAiQuotaNotice.css';

const SUARTE_PLUS_LABEL = 'Suarte Plus';

export default function AskAiQuotaNotice({ message, onSuartePlusClick }) {
  if (!message) {
    return null;
  }

  const suartePlusIndex = message.indexOf(SUARTE_PLUS_LABEL);
  const hasSuartePlusAction = suartePlusIndex !== -1 && typeof onSuartePlusClick === 'function';

  return (
    <div role="status" aria-live="polite">
      <Text className="ask-ai-quota-notice font-size-small" paragraph>
        {hasSuartePlusAction ? (
          <>
            {message.slice(0, suartePlusIndex)}
            <button
              type="button"
              className="ask-ai-quota-notice__upgrade"
              onClick={onSuartePlusClick}
            >
              {SUARTE_PLUS_LABEL}
            </button>
            {message.slice(suartePlusIndex + SUARTE_PLUS_LABEL.length)}
          </>
        ) : message}
      </Text>
    </div>
  );
}

AskAiQuotaNotice.propTypes = {
  message: PropTypes.string,
  onSuartePlusClick: PropTypes.func,
};
